const ReportsTableRow = ({ item, index, formatCurrency, getStatusColor }) => {
  return (
    <div
      className={`table-row ${index % 2 === 0 ? 'row-even' : 'row-odd'}`}
    >
      <div className="table-cell">{item.code}</div>
      <div className="table-cell table-cell-vehicle">{item.vehicle}</div>
      <div className="table-cell table-cell-right">
        {formatCurrency(item.mo_lataria)}
      </div>
      <div className="table-cell table-cell-right">
        {item.qtd_horas_lataria.toFixed(2)}
      </div>
      <div className="table-cell table-cell-right">
        {item.qtd_pecas_pintadas.toFixed(0)}
      </div>
      <div className="table-cell table-cell-right">
        {formatCurrency(item.mo_estetica)}
      </div>
      <div className="table-cell table-cell-right">
        {item.qtd_horas_estetica.toFixed(2)}
      </div>
      <div className="table-cell table-cell-right">
        {formatCurrency(item.valor_pecas)}
      </div>
      <div className="table-cell table-cell-right">
        {formatCurrency(item.custo_pecas)}
      </div>
      <div className="table-cell table-cell-right table-cell-lucro">
        {formatCurrency(item.lucro_pecas)}
      </div>
      <div className="table-cell table-cell-right table-cell-total">
        {formatCurrency(item.total_os)}
      </div>
      <div className="table-cell">
        <div
          className="status-badge"
          style={{
            backgroundColor: getStatusColor(item.status),
          }}
        >
          {item.status}
        </div>
      </div>
      <div className="table-cell">{item.previsao_entrega}</div>
    </div>
  );
};

export default ReportsTableRow;
